<template>
  <div class="errors-list-container">
    <div class="errors-list-title">{{ texts.body }}</div>
    <ul class="errors-list">
      <li v-for="messageError in props.errors" class="errors-list-item">
          <div class="errors-list-item-img"><img :src="icon" /></div>
          <span v-html="messageError" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'

const { t } = useI18n()

const props = defineProps<{
  errors: string[],
  description: string }>()

const texts = {
  body: props.description || t('components.dialog.maintenance_errors_list_description_default').toString(),
  primaryButtonText: t('action_buttons.accept').toString()
}

const icon = computed(() => {
  return require('@/assets/images/svg/Track-Right.svg')
})

</script>

<style scoped lang="scss">
.errors-list-container {
  @include borders($color: $main-200);
  gap: $spacing-xs;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
  background-color: $neutral-white-000;
  padding: $spacing-sm;
  border-radius: $cornerRadius-sm;
  min-height: 120px;

  .errors-list-title {
    @include milano-bold-14;
    color: $main-1000;
    padding: $spacing-sm $spacing-xs;
    border-bottom: 2px solid $main-1000;
  }

  .errors-list {
    list-style-type: none;
    padding: 0;
    &-item {
      @include arial-regular-12;
      display: flex;
      align-items: center;
      padding: $spacing-xs;
      border-bottom: 1px solid $main-200;

      &:last-child {
        border-bottom: none;
      }

      &-img {
        display: flex;
        padding: $spacing-xxs;
        justify-content: center;
        align-items: center;
        gap: $spacing-xs;
        border-radius: $cornerRadius-sm;
        background-color: $tertiary-persianRed-050;
        margin-right: $spacing-xs;
      }
    }
  }
}
</style>
